import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import Faq from '../../../components/Faq';
import typesLottie from '../../../public/images/types.json';
import Why from '../../../components/Why';
import ViewMore from '../../../components/ViewMore';
import BenefitsRealEstate from '../../../components/video-production/explainer-videos/BenefitsRealEstate';
import ProcessSliderRealExplainer from '../../../components/sliders/ProcessSliderRealExplainer';
import SolveProblemsRealEstate from '../../../components/video-production/explainer-videos/SolveProblemsRealEstate';

lazyload({
  width: '100%',
});

const ExplainerVideosRealEstate = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Real Estate Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/real-estate-explainer-video" />
        <meta
          name="description"
          content="Craft compelling real estate explainer videos in Yerevan to showcase properties effectively. Elevate your marketing with professional production expertise."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/real-estate-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Real Estate Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Craft compelling real estate explainer videos in Yerevan to showcase properties effectively. Elevate your marketing with professional production expertise."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/real-estate-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
  "@context": "http://schema.org",
  "@type": "WebPage",
  "name": "Video Production - Real Estate Explainer Video | Prodigi",
  "description": "Craft compelling real estate explainer videos in Yerevan to showcase properties effectively. Elevate your marketing with professional production expertise.",
  "url": "https://weprodigi.com/video-production/real-estate-explainer-video",
  "breadcrumb": {
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://weprodigi.com"
      },
      {
        "@type": "ListItem",
        "position": 2,
        "name": "Full Service Video Production",
        "item": "https://weprodigi.com/video-production"
      },
      {
        "@type": "ListItem",
        "position": 3,
        "name": "Real Estate Explainer Video Production",
        "item": "https://weprodigi.com/video-production/real-estate-explainer-video"
      }
    ]
  },
  "mainEntity": {
    "@type": "Product",
    "name": "Real Estate Explainer Video Production",
    "description": "Craft compelling real estate explainer videos in Yerevan to showcase properties effectively. Elevate your marketing with professional production expertise.",
    "brand": {
      "@type": "Brand",
      "name": "Weprodigi"
    },
    "offers": {
      "@type": "Offer",
      "price": "1300",
      "priceCurrency": "USD",
      "seller": {
        "@type": "Organization",
        "name": "Weprodigi"
      }
    },
    "image": "https://weprodigi.com/images/logovertical.svg",
    "review": [
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Rachel Harris"
        },
        "datePublished": "2024-12-10",
        "reviewBody": "Prodigi offers valuable insights into the world of real estate in a visually appealing and easy-to-understand format."
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "5",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Kevin Nikson"
        },
        "datePublished": "2024-12-16",
        "reviewBody": "Prodigi's real estate explainer videos are top-notch! They deliver comprehensive information on real estate topics clearly and concisely, making them a must-watch for anyone interested in the industry."
      },
      {
        "@type": "Review",
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "4.9",
          "bestRating": "5",
          "worstRating": "1"
        },
        "author": {
          "@type": "Person",
          "name": "Jennifer Davies"
        },
        "datePublished": "2024-02-18",
        "reviewBody": "They break down intricate real estate concepts into easily digestible pieces, making it effortless for viewers to grasp important information."
      }
    ],
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "reviewCount": "3"
    }
  }
} `,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/real-estate-explainer/real-estate-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Real Estate Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/real-estate-explainer-video',
                name: 'Real Estate Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A real estate explainer video can become a virtual tour of a property. It will highlight all the benefits of a property. With this
                  video format, it will stop being just a place. You can give the visualization of someone’s dream house and show that the process is
                  so easy!
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full lg:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is a Real Estate Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/nvGGvURtmY0?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Missouri Realtors | Real Estate Explainer Video</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                How to simplify the complexities of the real estate market? It’s so easy with real estate animated explainer videos. Whether you are
                buying, selling, or investing, these videos provide a visual and engaging way to learn about the process. They help to understand
                market trends and explore properties. With it, everyone can navigate the real estate market with confidence.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  How to simplify the complexities of the real estate market? It’s so easy with real estate animated explainer videos. Whether you are
                  buying, selling, or investing, these videos provide a visual and engaging way to learn about the process. They help to understand
                  market trends and explore properties. With it, everyone can navigate the real estate market with confidence.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where to Use Real Estate Explainer Videos?
            </h2>
            <p className={'mt-20'}>
              Are you looking for an improvement in the real estate industry? Scroll down to learn what explainer video production can offer.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/VkGLGYpB43E?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>
                  Teddington Development | Real Estate Explainer Video
                </p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  How can marketing and advertising efforts in the real estate industry be improved? Real estate video marketing will do everything.
                  It will serve as a tie with potential buyers. Videos are easy to share on various platforms. This benefit makes it possible to use
                  them in social media ads, landing pages, e-commerce or retail platforms, email marketing, etc. Visualized advantages of property
                  bring better attention.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    How can marketing and advertising efforts in the real estate industry be improved? Real estate video marketing will do everything.
                    It will serve as a tie with potential buyers. Videos are easy to share on various platforms. This benefit makes it possible to use
                    them in social media ads, landing pages, e-commerce or retail platforms, email marketing, etc. Visualized advantages of property
                    bring better attention.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  Well-made real estate animated explainer videos will become an effective tool in training real estate experts. They will explain
                  property law, market analysis, and negotiation techniques. Apart from easy descriptions, videos will bring more interest into
                  learning sessions. Students can watch and rewatch the content at their own pace. Videos will also promote your courses on various
                  platforms.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Well-made real estate animated explainer videos will become an effective tool in training real estate experts. They will explain
                    property law, market analysis, and negotiation techniques. Apart from easy descriptions, videos will bring more interest into
                    learning sessions. Students can watch and rewatch the content at their own pace. Videos will also promote your courses on various
                    platforms.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/9-YWEzmIZiw?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Cozii | Real Estate Explainer Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/hq2VTA_MaU0?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>AI Building Designs | Real Estate Explainer Video</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Customer Service</h3>
                <p className={'mt-16 hidden md:block'}>
                  Answering all the customers' questions takes time. But now there's a solution to make it faster. Not only faster but effective. The
                  solution is a real estate explainer. There’s a way to create real estate video content from the FAQ series. The videos will answer
                  all the questions about buying and selling homes. Additionally, videos will give information about properties and neighborhood
                  overviews. Virtual tours with explainer videos will make an easy real estate journey.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    Answering all the customers' questions takes time. But now there's a solution to make it faster. Not only faster but effective.
                    The solution is a real estate explainer. There’s a way to create real estate video content from the FAQ series. The videos will
                    answer all the questions about buying and selling homes. Additionally, videos will give information about properties and
                    neighborhood overviews. Virtual tours with explainer videos will make an easy real estate journey.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Real Estate Explainer Videos
            </h2>
            <p className={'mt-20'}>Explainer videos can change everything for the better. Learn more about their main benefits.</p>
            <Suspense fallback={`Loading...`}>
              <BenefitsRealEstate />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Real Explainer Video Production Process
            </h2>
            <ProcessSliderRealExplainer />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div
              className={
                'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-26 lg:text-36'
              }
            >
              CALCULATE YOUR REAL ESTATE EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Real Estate Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>What can be a good promotion? Mixing the benefits of explainer videos with the benefits of your business.</p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsRealEstate />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Real Estate Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We value your time.',
                  answer:
                    "We know how important our clients' time is. Outsourcing full-service video production helps save your expensive time. More importantly, we quickly understand your business needs and implement our proven time-saving solutions at all stages of production, from communication to payment methods.",
                },
                {
                  title: 'We include digital marketing specialists in the production process.',
                  answer:
                    "According to Google, 6 out of 10 people prefer watching videos online rather than TV. To create an effective video, you need to consider which platform the video will be used on and master all its features, be it your website, YouTube, Facebook, or Amazon. That's why we include our digital marketing specialists in the production process, who study your business requirements in detail and combine them with the requirements of each online platform to get effective material.",
                },
                {
                  title: "We don't require prepayment.",
                  answer:
                    "The client should pay for the work rather than with deposits. We chose a milestone  payment option as it's a more trustworthy approach to our work.",
                },
                {
                  title: "We don't have a single unhappy client.",
                  answer:
                    'We never charge for a product that you have not approved. If you are unsatisfied with the results, 100% money-back is guaranteed.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'What makes a successful real estate explainer video?',
                    answer:
                      'First of all, the professional approach. After, well-crafted information, engaging script, impactful visuals, and audio effects.',
                  },
                  {
                    title: 'How long should a real estate explainer video be?',
                    answer:
                      '30-second real estate explainer videos are the shortest. The duration of the videos depends on the topic, but it should be 3 minutes at maximum.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'What are some common types of real estate explainer videos?',
                    answer: 'The most common types of real estate videos are property listings, market updates, and educational content. ',
                  },
                  {
                    title: 'Where can I use real estate explainer videos?',
                    answer:
                      'The flexible format of these videos makes it possible to use them on different platforms: social media, email campaigns, websites, etc.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosRealEstate;
